import React, { Component } from 'react';
import { MobileElementControls, DesktopElementControls } from 'crazyEditor/components';

export default class ElementControls extends Component {
  render() {
    const { isMobileView, isDesktopView } = this.props;
    if (isMobileView) {
      return <MobileElementControls />;
    }
    if (isDesktopView) {
      return <DesktopElementControls />;
    }
    return null;
  }
}
